/**
 * Axios serializes an explicit `data: null` as the JSON body `null`.
 * Express' strict JSON parser rejects that primitive before the request
 * reaches the route. Bodyless operations must omit `data` altogether.
 */
export function withOptionalRequestData(config, data) {
  if (data === null || data === undefined) {
    return config;
  }

  return {
    ...config,
    data,
  };
}
